export default __webpack_public_path__ + "static/media/The Helot of Sacrilege.7fc7b0db.jpg";